import React, { useEffect, useRef } from 'react';
import { usePopper } from 'react-popper';
import { Portal } from '../Portal/index.js';
const defaultProps = {
    placement: 'bottom',
    strategy: 'fixed'
};
/**
 * @deprecated This component can cause test warnings. Use usePopper instead.
 */
export function Popper({ anchorEl, children, placement, strategy, updatePlacement, ...passThrough }) {
    const popperRef = useRef(null);
    const { forceUpdate, styles } = usePopper(anchorEl, popperRef.current, {
        placement: placement,
        strategy: strategy
    });
    useEffect(() => {
        const timeout = setTimeout(() => {
            forceUpdate?.();
        }, 5);
        return () => {
            clearTimeout(timeout);
        };
    }, [updatePlacement]);
    return (React.createElement(Portal, null,
        React.createElement("div", { ref: popperRef, ...passThrough, style: styles['popper'] }, children)));
}
Popper.defaultProps = defaultProps;
//# sourceMappingURL=Popper.js.map